module.exports = __webpack_public_path__ + "static/media/i41img1.d4f7a1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/i41img1.jpg
// module id = 685
// module chunks = 0